import { Avatar, Box, ButtonBase, Stack, Typography } from '@mui/material';
import { ControlledAutocomplete } from 'Components/ControlledAutoComplete';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleSearchIcon, PurpleX } from 'Images';
import { useState } from 'react';

interface IDocumentsSearchBar {
  options: string[];
  onChange: (value: string) => void;
}
export const DocumentsSearchBar = ({
  onChange,
  options,
}: IDocumentsSearchBar) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);
  const [inputValue, setInputValue] = useState('');
  const isDesktop = useIsDesktop();

  const filteredOptions = options.filter((option) =>
    option.includes(inputValue)
  );

  return (
    <ControlledAutocomplete
      freeSolo
      label={dictionary.searchBarLabel}
      options={filteredOptions}
      setValue={(value: string | null) => {
        onChange(value ?? '');
      }}
      inputValue={inputValue}
      inputLabelProps={{
        shrink: false,
        sx: { display: inputValue ? 'none' : 'block' },
      }}
      setInputValue={(value) => setInputValue(value)}
      paperComponent={
        filteredOptions.length === 0 && (
          <Stack>
            <Typography variant={'body3'}>
              {dictionary.noResultsText}
            </Typography>
          </Stack>
        )
      }
      paperSx={{
        mt: '1px',
        ml: '10px',
        width: isDesktop ? '425px' : '93%',
      }}
      style={{
        borderRadius: '34px',
        border: '1px solid',
        borderColor: 'primary.shade_200',

        '&&& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '34px',
          bgcolor: '#fff',
          zIndex: -1,
          borderColor: 'primary.shade_200',
          borderWidth: '1px',
        },
        '&&& .MuiInputBase-root input[dropdown="open"] ~ fieldset': {
          borderColor: 'transparent',
        },
      }}
      disableClearIcon
      endAdornment={
        <Stack
          direction={'row'}
          marginRight={'5px'}
          width={'auto'}
          gap={'15px'}
        >
          {inputValue.length > 0 && (
            <ButtonBase
              onClick={() => {
                setInputValue('');
                onChange('');
              }}
            >
              <Avatar
                src={PurpleX}
                alt={''}
                sx={{ width: '20px', height: '20px' }}
              />
            </ButtonBase>
          )}
          <Avatar
            alt={''}
            src={PurpleSearchIcon}
            sx={{
              width: isDesktop ? '37px' : '31px',
              height: isDesktop ? '37px' : '31px',
            }}
            onClick={() => {
              onChange(inputValue);
            }}
          />
        </Stack>
      }
    />
  );
};
